// src/utils/pushUtils.js
export async function enableNotifications() {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    alert("Notifications not supported in this browser.");
    return false;
  }

  // Already granted → maybe show a toast "Already enabled" or proceed to subscribe
  if (Notification.permission === "granted") {
    console.log("Notifications already enabled.");
    // Optional: trigger subscription if not done yet
    await subscribeToPush(); // implement below if needed
    return true;
  }

  if (Notification.permission === "denied") {
    alert("Notifications blocked. Please enable in browser settings.");
    return false;
  }

  // Request permission (this shows the browser prompt)
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    console.log("Permission granted!");
    // Now subscribe to push (VAPID part - add later)
    await subscribeToPush();
    alert("Notifications enabled! You'll receive updates.");
    return true;
  } else {
    console.log("Permission denied.");
    alert("Notifications not enabled.");
    return false;
  }
}

// Optional: full push subscription (add your VAPID public key here later)
async function subscribeToPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const vapidPublicKey = "YOUR_VAPID_PUBLIC_KEY_HERE"; // ← from .env or backend
    const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey,
    });

    // Send to your backend
    await fetch("/api/push/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(subscription),
    });

    console.log("Push subscribed!");
  } catch (err) {
    console.error("Subscription failed:", err);
  }
}

export function showStaticExpenseNotification(expenseData = {}) {
  console.log(
    "[NOTIF] Starting showStaticExpenseNotification - simplified version",
  );

  if (Notification.permission !== "granted") {
    console.warn("[NOTIF] Permission not granted:", Notification.permission);
    return;
  }

  console.log("[NOTIF] Permission is granted → proceeding");

  navigator.serviceWorker.ready
    .then((reg) => {
      console.log("[NOTIF] ServiceWorker ready! Scope:", reg.scope);
      console.log("[NOTIF] Registration active:", reg.active ? "yes" : "no");

      const title = "TEST STATIC NOTIFICATION";
      const options = {
        body: "This should appear NOW if everything is correct",
        // icon: "/icon-192.png", // make sure this file exists
        tag: "test-" + Date.now(),
      };

      console.log("[NOTIF] About to call showNotification...");
      reg.showNotification(title, options);
      console.log("[NOTIF] showNotification called (no await in this version)");
    })
    .catch((err) => {
      console.error(
        "[NOTIF] Critical error in service worker ready chain:",
        err,
      );
      console.error("[NOTIF] Error details:", err.name, err.message, err.stack);
    });
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
